export const sortAlphaNum = (a: any, b: any) => a.text.localeCompare(b.text, 'en', { numeric: true })
export const sortAlphaNumByKey = (a: any, b: any, key: string) => a[key].localeCompare(b[key], 'en', { numeric: true })
